
// Local
export const setLocalStorage = (key, data) => localStorage.setItem(key, JSON.stringify(data));

export const getLocalStorage = (key) => {
  if (localStorage.getItem(key) && localStorage.getItem(key) !== 'undefined') {
    return JSON.parse(localStorage.getItem(key));
  } else {
    return null;
  }
};

export const clearLocalStorage = () => {
  localStorage.clear();
}

// Session

export const setSessionStorage = (key, data) => sessionStorage.setItem(key, JSON.stringify(data));

export const getSessionStorage = (key) => {
  if (sessionStorage.getItem(key) && sessionStorage.getItem(key) !== 'undefined') {
    return JSON.parse(sessionStorage.getItem(key));
  }
};

export const clearSessionStorage = () => {
  sessionStorage.clear();
}

